export const symbolData: {
  codepoint: number;
  glyph: string;
  source?: {
    tableName:
      | 'Trait'
      | 'InventoryItem'
      | 'SandboxPerk'
      | 'ActivityMode'
      | 'Objective'
      | 'ItemCategory'
      | 'InventoryBucket'
      | 'Faction'
      | 'Stat'
      | 'DamageType';
    hash: number;
    fromRichText: boolean;
  };
}[] = [
  {
    codepoint: 983379,
    glyph: '󰅓',
    source: {
      tableName: 'InventoryItem',
      hash: 171056525,
      fromRichText: false,
    },
  },
  {
    codepoint: 57633,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 3769507633,
      fromRichText: false,
    },
  },
  {
    codepoint: 57443,
    glyph: '',
    source: {
      tableName: 'SandboxPerk',
      hash: 2236497009,
      fromRichText: false,
    },
  },
  {
    codepoint: 61181,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 3769507632,
      fromRichText: false,
    },
  },
  {
    codepoint: 57634,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 119041299,
      fromRichText: false,
    },
  },
  {
    codepoint: 57432,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 119041298,
      fromRichText: false,
    },
  },
  {
    codepoint: 57637,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 1081893460,
      fromRichText: false,
    },
  },
  {
    codepoint: 57445,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 1081893461,
      fromRichText: false,
    },
  },
  {
    codepoint: 61235,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 2370269388,
      fromRichText: false,
    },
  },
  {
    codepoint: 57635,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 375052469,
      fromRichText: false,
    },
  },
  {
    codepoint: 983041,
    glyph: '󰀁',
    source: {
      tableName: 'InventoryItem',
      hash: 375052468,
      fromRichText: false,
    },
  },
  {
    codepoint: 57442,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 375052471,
      fromRichText: false,
    },
  },
  {
    codepoint: 57638,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 2529942647,
      fromRichText: false,
    },
  },
  {
    codepoint: 57440,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 2747500760,
      fromRichText: false,
    },
  },
  {
    codepoint: 57625,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 2274196886,
      fromRichText: false,
    },
  },
  {
    codepoint: 983040,
    glyph: '󰀀',
    source: {
      tableName: 'InventoryItem',
      hash: 2274196886,
      fromRichText: false,
    },
  },
  {
    codepoint: 57430,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 2274196887,
      fromRichText: false,
    },
  },
  {
    codepoint: 61237,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 1869939005,
      fromRichText: false,
    },
  },
  {
    codepoint: 57639,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 2370269389,
      fromRichText: false,
    },
  },
  {
    codepoint: 983044,
    glyph: '󰀄',
    source: {
      tableName: 'InventoryItem',
      hash: 2722573681,
      fromRichText: false,
    },
  },
  {
    codepoint: 57431,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 2722573682,
      fromRichText: false,
    },
  },
  {
    codepoint: 57640,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 4260353952,
      fromRichText: false,
    },
  },
  {
    codepoint: 57441,
    glyph: '',
    source: {
      tableName: 'SandboxPerk',
      hash: 3112248479,
      fromRichText: false,
    },
  },
  {
    codepoint: 983045,
    glyph: '󰀅',
    source: {
      tableName: 'InventoryItem',
      hash: 4260353953,
      fromRichText: false,
    },
  },
  {
    codepoint: 57632,
    glyph: '',
    source: {
      tableName: 'SandboxPerk',
      hash: 3484134371,
      fromRichText: false,
    },
  },
  {
    codepoint: 983042,
    glyph: '󰀂',
    source: {
      tableName: 'InventoryItem',
      hash: 1656118682,
      fromRichText: false,
    },
  },
  {
    codepoint: 983043,
    glyph: '󰀃',
    source: {
      tableName: 'InventoryItem',
      hash: 1656118681,
      fromRichText: false,
    },
  },
  {
    codepoint: 57444,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 1656118680,
      fromRichText: false,
    },
  },
  {
    codepoint: 61238,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 2529942646,
      fromRichText: false,
    },
  },
  {
    codepoint: 57476,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 2370269391,
      fromRichText: false,
    },
  },
  {
    codepoint: 57475,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 2021620139,
      fromRichText: false,
    },
  },
  {
    codepoint: 57477,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 1869939006,
      fromRichText: false,
    },
  },
  {
    codepoint: 61195,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 2370269384,
      fromRichText: false,
    },
  },
  {
    codepoint: 61196,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 2529942642,
      fromRichText: false,
    },
  },
  {
    codepoint: 61197,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 1869939001,
      fromRichText: false,
    },
  },
  {
    codepoint: 57616,
    glyph: '',
    source: {
      tableName: 'SandboxPerk',
      hash: 729990577,
      fromRichText: true,
    },
  },
  {
    codepoint: 983058,
    glyph: '󰀒',
    source: {
      tableName: 'InventoryItem',
      hash: 2657901005,
      fromRichText: false,
    },
  },
  {
    codepoint: 983064,
    glyph: '󰀘',
    source: {
      tableName: 'InventoryItem',
      hash: 2716335210,
      fromRichText: false,
    },
  },
  {
    codepoint: 983132,
    glyph: '󰁜',
    source: {
      tableName: 'InventoryItem',
      hash: 2708585277,
      fromRichText: false,
    },
  },
  {
    codepoint: 983049,
    glyph: '󰀉',
    source: {
      tableName: 'InventoryItem',
      hash: 2708585276,
      fromRichText: false,
    },
  },
  {
    codepoint: 61179,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 1980796563,
      fromRichText: false,
    },
  },
  {
    codepoint: 983056,
    glyph: '󰀐',
    source: {
      tableName: 'InventoryItem',
      hash: 1232050831,
      fromRichText: false,
    },
  },
  {
    codepoint: 983048,
    glyph: '󰀈',
    source: {
      tableName: 'InventoryItem',
      hash: 1232050830,
      fromRichText: false,
    },
  },
  {
    codepoint: 57636,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 3710811138,
      fromRichText: false,
    },
  },
  {
    codepoint: 983112,
    glyph: '󰁈',
    source: {
      tableName: 'InventoryItem',
      hash: 4016776974,
      fromRichText: false,
    },
  },
  {
    codepoint: 983113,
    glyph: '󰁉',
    source: {
      tableName: 'InventoryItem',
      hash: 4016776973,
      fromRichText: false,
    },
  },
  {
    codepoint: 983114,
    glyph: '󰁊',
    source: {
      tableName: 'InventoryItem',
      hash: 2657901004,
      fromRichText: false,
    },
  },
  {
    codepoint: 983115,
    glyph: '󰁋',
    source: {
      tableName: 'InventoryItem',
      hash: 4016776975,
      fromRichText: false,
    },
  },
  {
    codepoint: 983100,
    glyph: '󰀼',
    source: {
      tableName: 'InventoryItem',
      hash: 852252788,
      fromRichText: false,
    },
  },
  {
    codepoint: 57447,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 852252789,
      fromRichText: false,
    },
  },
  {
    codepoint: 983055,
    glyph: '󰀏',
    source: {
      tableName: 'InventoryItem',
      hash: 1470370539,
      fromRichText: false,
    },
  },
  {
    codepoint: 57622,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 1470370538,
      fromRichText: false,
    },
  },
  {
    codepoint: 61236,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 83039192,
      fromRichText: false,
    },
  },
  {
    codepoint: 983137,
    glyph: '󰁡',
    source: {
      tableName: 'InventoryItem',
      hash: 1139822081,
      fromRichText: false,
    },
  },
  {
    codepoint: 57618,
    glyph: '',
    source: {
      tableName: 'Objective',
      hash: 1157531927,
      fromRichText: false,
    },
  },
  {
    codepoint: 983135,
    glyph: '󰁟',
    source: {
      tableName: 'InventoryItem',
      hash: 4220332375,
      fromRichText: false,
    },
  },
  {
    codepoint: 57493,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 1980796560,
      fromRichText: false,
    },
  },
  {
    codepoint: 57494,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 2299867342,
      fromRichText: false,
    },
  },
  {
    codepoint: 57479,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 1341767667,
      fromRichText: false,
    },
  },
  {
    codepoint: 57478,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 1980796561,
      fromRichText: false,
    },
  },
  {
    codepoint: 57480,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 2543177538,
      fromRichText: false,
    },
  },
  {
    codepoint: 61190,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 1680616210,
      fromRichText: false,
    },
  },
  {
    codepoint: 61191,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 1980796564,
      fromRichText: false,
    },
  },
  {
    codepoint: 61192,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 2307689415,
      fromRichText: false,
    },
  },
  {
    codepoint: 57617,
    glyph: '',
    source: {
      tableName: 'SandboxPerk',
      hash: 528482921,
      fromRichText: true,
    },
  },
  {
    codepoint: 983076,
    glyph: '󰀤',
    source: {
      tableName: 'InventoryItem',
      hash: 1582574009,
      fromRichText: false,
    },
  },
  {
    codepoint: 983079,
    glyph: '󰀧',
    source: {
      tableName: 'InventoryItem',
      hash: 2909720723,
      fromRichText: false,
    },
  },
  {
    codepoint: 983080,
    glyph: '󰀨',
    source: {
      tableName: 'InventoryItem',
      hash: 4198689901,
      fromRichText: false,
    },
  },
  {
    codepoint: 983084,
    glyph: '󰀬',
    source: {
      tableName: 'InventoryItem',
      hash: 2994412667,
      fromRichText: false,
    },
  },
  {
    codepoint: 983086,
    glyph: '󰀮',
    source: {
      tableName: 'InventoryItem',
      hash: 1323461861,
      fromRichText: false,
    },
  },
  {
    codepoint: 983088,
    glyph: '󰀰',
    source: {
      tableName: 'InventoryItem',
      hash: 146194908,
      fromRichText: false,
    },
  },
  {
    codepoint: 983090,
    glyph: '󰀲',
    source: {
      tableName: 'InventoryItem',
      hash: 2481624867,
      fromRichText: false,
    },
  },
  {
    codepoint: 983078,
    glyph: '󰀦',
    source: {
      tableName: 'InventoryItem',
      hash: 2202441959,
      fromRichText: false,
    },
  },
  {
    codepoint: 983081,
    glyph: '󰀩',
    source: {
      tableName: 'InventoryItem',
      hash: 1013086087,
      fromRichText: false,
    },
  },
  {
    codepoint: 983082,
    glyph: '󰀪',
    source: {
      tableName: 'InventoryItem',
      hash: 1841016428,
      fromRichText: false,
    },
  },
  {
    codepoint: 983083,
    glyph: '󰀫',
    source: {
      tableName: 'InventoryItem',
      hash: 2581086849,
      fromRichText: false,
    },
  },
  {
    codepoint: 983089,
    glyph: '󰀱',
    source: {
      tableName: 'InventoryItem',
      hash: 2216698406,
      fromRichText: false,
    },
  },
  {
    codepoint: 983092,
    glyph: '󰀴',
    source: {
      tableName: 'InventoryItem',
      hash: 2842514288,
      fromRichText: false,
    },
  },
  {
    codepoint: 983093,
    glyph: '󰀵',
    source: {
      tableName: 'InventoryItem',
      hash: 2400634603,
      fromRichText: false,
    },
  },
  {
    codepoint: 983094,
    glyph: '󰀶',
    source: {
      tableName: 'InventoryItem',
      hash: 2946990961,
      fromRichText: false,
    },
  },
  {
    codepoint: 983077,
    glyph: '󰀥',
    source: {
      tableName: 'InventoryItem',
      hash: 3232422679,
      fromRichText: false,
    },
  },
  {
    codepoint: 983085,
    glyph: '󰀭',
    source: {
      tableName: 'InventoryItem',
      hash: 886607940,
      fromRichText: false,
    },
  },
  {
    codepoint: 983087,
    glyph: '󰀯',
    source: {
      tableName: 'InventoryItem',
      hash: 1514173218,
      fromRichText: false,
    },
  },
  {
    codepoint: 983091,
    glyph: '󰀳',
    source: {
      tableName: 'InventoryItem',
      hash: 2265076177,
      fromRichText: false,
    },
  },
  {
    codepoint: 983095,
    glyph: '󰀷',
    source: {
      tableName: 'InventoryItem',
      hash: 1255073825,
      fromRichText: false,
    },
  },
  {
    codepoint: 983096,
    glyph: '󰀸',
    source: {
      tableName: 'InventoryItem',
      hash: 2809141585,
      fromRichText: false,
    },
  },
  {
    codepoint: 983097,
    glyph: '󰀹',
    source: {
      tableName: 'InventoryItem',
      hash: 1016030582,
      fromRichText: false,
    },
  },
  {
    codepoint: 57472,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 1399219,
      fromRichText: false,
    },
  },
  {
    codepoint: 57473,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 1399216,
      fromRichText: false,
    },
  },
  {
    codepoint: 57474,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 1399217,
      fromRichText: false,
    },
  },
  {
    codepoint: 61186,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 1517917190,
      fromRichText: false,
    },
  },
  {
    codepoint: 61187,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 3994381207,
      fromRichText: false,
    },
  },
  {
    codepoint: 61188,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 1225978592,
      fromRichText: false,
    },
  },
  {
    codepoint: 61242,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 1005476557,
      fromRichText: false,
    },
  },
  {
    codepoint: 61241,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 275534325,
      fromRichText: false,
    },
  },
  {
    codepoint: 61243,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 1324853482,
      fromRichText: false,
    },
  },
  {
    codepoint: 983306,
    glyph: '󰄊',
    source: {
      tableName: 'InventoryItem',
      hash: 405131479,
      fromRichText: false,
    },
  },
  {
    codepoint: 983066,
    glyph: '󰀚',
    source: {
      tableName: 'InventoryItem',
      hash: 426473317,
      fromRichText: false,
    },
  },
  {
    codepoint: 983067,
    glyph: '󰀛',
    source: {
      tableName: 'InventoryItem',
      hash: 426473316,
      fromRichText: false,
    },
  },
  {
    codepoint: 983065,
    glyph: '󰀙',
    source: {
      tableName: 'InventoryItem',
      hash: 2711519343,
      fromRichText: false,
    },
  },
  {
    codepoint: 61234,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 2835214901,
      fromRichText: false,
    },
  },
  {
    codepoint: 983050,
    glyph: '󰀊',
    source: {
      tableName: 'InventoryItem',
      hash: 489583097,
      fromRichText: false,
    },
  },
  {
    codepoint: 983051,
    glyph: '󰀋',
    source: {
      tableName: 'InventoryItem',
      hash: 489583096,
      fromRichText: false,
    },
  },
  {
    codepoint: 983146,
    glyph: '󰁪',
    source: {
      tableName: 'InventoryItem',
      hash: 489583098,
      fromRichText: false,
    },
  },
  {
    codepoint: 983128,
    glyph: '󰁘',
    source: {
      tableName: 'InventoryItem',
      hash: 25156514,
      fromRichText: false,
    },
  },
  {
    codepoint: 983129,
    glyph: '󰁙',
    source: {
      tableName: 'InventoryItem',
      hash: 25156515,
      fromRichText: false,
    },
  },
  {
    codepoint: 983125,
    glyph: '󰁕',
    source: {
      tableName: 'InventoryItem',
      hash: 1444664836,
      fromRichText: false,
    },
  },
  {
    codepoint: 983380,
    glyph: '󰅔',
    source: {
      tableName: 'InventoryItem',
      hash: 230819033,
      fromRichText: false,
    },
  },
  {
    codepoint: 983109,
    glyph: '󰁅',
    source: {
      tableName: 'InventoryItem',
      hash: 20616658,
      fromRichText: false,
    },
  },
  {
    codepoint: 983110,
    glyph: '󰁆',
    source: {
      tableName: 'InventoryItem',
      hash: 20616659,
      fromRichText: false,
    },
  },
  {
    codepoint: 983111,
    glyph: '󰁇',
    source: {
      tableName: 'InventoryItem',
      hash: 20616656,
      fromRichText: false,
    },
  },
  {
    codepoint: 983119,
    glyph: '󰁏',
    source: {
      tableName: 'InventoryItem',
      hash: 266130437,
      fromRichText: false,
    },
  },
  {
    codepoint: 983120,
    glyph: '󰁐',
    source: {
      tableName: 'InventoryItem',
      hash: 266130439,
      fromRichText: false,
    },
  },
  {
    codepoint: 983121,
    glyph: '󰁑',
    source: {
      tableName: 'InventoryItem',
      hash: 266130438,
      fromRichText: false,
    },
  },
  {
    codepoint: 983073,
    glyph: '󰀡',
    source: {
      tableName: 'InventoryItem',
      hash: 5333294,
      fromRichText: false,
    },
  },
  {
    codepoint: 983074,
    glyph: '󰀢',
    source: {
      tableName: 'InventoryItem',
      hash: 5333293,
      fromRichText: false,
    },
  },
  {
    codepoint: 983075,
    glyph: '󰀣',
    source: {
      tableName: 'InventoryItem',
      hash: 5333292,
      fromRichText: false,
    },
  },
  {
    codepoint: 983054,
    glyph: '󰀎',
    source: {
      tableName: 'InventoryItem',
      hash: 5333295,
      fromRichText: false,
    },
  },
  {
    codepoint: 983301,
    glyph: '󰄅',
    source: {
      tableName: 'InventoryItem',
      hash: 483775550,
      fromRichText: false,
    },
  },
  {
    codepoint: 983176,
    glyph: '󰂈',
    source: {
      tableName: 'InventoryItem',
      hash: 190429600,
      fromRichText: false,
    },
  },
  {
    codepoint: 983070,
    glyph: '󰀞',
    source: {
      tableName: 'InventoryItem',
      hash: 4194622036,
      fromRichText: false,
    },
  },
  {
    codepoint: 983118,
    glyph: '󰁎',
    source: {
      tableName: 'InventoryItem',
      hash: 4194622038,
      fromRichText: false,
    },
  },
  {
    codepoint: 983145,
    glyph: '󰁩',
    source: {
      tableName: 'InventoryItem',
      hash: 4194622037,
      fromRichText: false,
    },
  },
  {
    codepoint: 983108,
    glyph: '󰁄',
    source: {
      tableName: 'InventoryItem',
      hash: 1656549673,
      fromRichText: false,
    },
  },
  {
    codepoint: 983117,
    glyph: '󰁍',
    source: {
      tableName: 'InventoryItem',
      hash: 1262901523,
      fromRichText: false,
    },
  },
  {
    codepoint: 983148,
    glyph: '󰁬',
    source: {
      tableName: 'InventoryItem',
      hash: 1656549672,
      fromRichText: false,
    },
  },
  {
    codepoint: 983047,
    glyph: '󰀇',
    source: {
      tableName: 'InventoryItem',
      hash: 1293395731,
      fromRichText: false,
    },
  },
  {
    codepoint: 57624,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 1293395731,
      fromRichText: false,
    },
  },
  {
    codepoint: 983068,
    glyph: '󰀜',
    source: {
      tableName: 'InventoryItem',
      hash: 1293395729,
      fromRichText: false,
    },
  },
  {
    codepoint: 61180,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 790664812,
      fromRichText: false,
    },
  },
  {
    codepoint: 57621,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 2835214903,
      fromRichText: false,
    },
  },
  {
    codepoint: 983099,
    glyph: '󰀻',
    source: {
      tableName: 'InventoryItem',
      hash: 2835214903,
      fromRichText: false,
    },
  },
  {
    codepoint: 983116,
    glyph: '󰁌',
    source: {
      tableName: 'InventoryItem',
      hash: 3066103998,
      fromRichText: false,
    },
  },
  {
    codepoint: 983123,
    glyph: '󰁓',
    source: {
      tableName: 'InventoryItem',
      hash: 3066103999,
      fromRichText: false,
    },
  },
  {
    codepoint: 57620,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 1262901520,
      fromRichText: false,
    },
  },
  {
    codepoint: 983130,
    glyph: '󰁚',
    source: {
      tableName: 'InventoryItem',
      hash: 2984351204,
      fromRichText: false,
    },
  },
  {
    codepoint: 983138,
    glyph: '󰁢',
    source: {
      tableName: 'InventoryItem',
      hash: 2984351205,
      fromRichText: false,
    },
  },
  {
    codepoint: 983101,
    glyph: '󰀽',
    source: {
      tableName: 'InventoryItem',
      hash: 83039194,
      fromRichText: false,
    },
  },
  {
    codepoint: 983103,
    glyph: '󰀿',
    source: {
      tableName: 'InventoryItem',
      hash: 83039195,
      fromRichText: false,
    },
  },
  {
    codepoint: 983147,
    glyph: '󰁫',
    source: {
      tableName: 'InventoryItem',
      hash: 83039193,
      fromRichText: false,
    },
  },
  {
    codepoint: 983142,
    glyph: '󰁦',
    source: {
      tableName: 'InventoryItem',
      hash: 187655374,
      fromRichText: false,
    },
  },
  {
    codepoint: 983150,
    glyph: '󰁮',
    source: {
      tableName: 'InventoryItem',
      hash: 187655372,
      fromRichText: false,
    },
  },
  {
    codepoint: 57495,
    glyph: '',
  },
  {
    codepoint: 983151,
    glyph: '󰁯',
    source: {
      tableName: 'InventoryItem',
      hash: 187655373,
      fromRichText: false,
    },
  },
  {
    codepoint: 983052,
    glyph: '󰀌',
    source: {
      tableName: 'InventoryItem',
      hash: 1602994569,
      fromRichText: false,
    },
  },
  {
    codepoint: 983122,
    glyph: '󰁒',
    source: {
      tableName: 'InventoryItem',
      hash: 1602994570,
      fromRichText: false,
    },
  },
  {
    codepoint: 983057,
    glyph: '󰀑',
    source: {
      tableName: 'InventoryItem',
      hash: 2321824285,
      fromRichText: false,
    },
  },
  {
    codepoint: 57491,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 2321824287,
      fromRichText: false,
    },
  },
  {
    codepoint: 983069,
    glyph: '󰀝',
    source: {
      tableName: 'InventoryItem',
      hash: 790664815,
      fromRichText: false,
    },
  },
  {
    codepoint: 983098,
    glyph: '󰀺',
    source: {
      tableName: 'InventoryItem',
      hash: 1920417385,
      fromRichText: false,
    },
  },
  {
    codepoint: 983134,
    glyph: '󰁞',
    source: {
      tableName: 'InventoryItem',
      hash: 2934767476,
      fromRichText: false,
    },
  },
  {
    codepoint: 983149,
    glyph: '󰁭',
    source: {
      tableName: 'InventoryItem',
      hash: 4184589900,
      fromRichText: false,
    },
  },
  {
    codepoint: 983153,
    glyph: '󰁱',
    source: {
      tableName: 'InventoryItem',
      hash: 2835214902,
      fromRichText: false,
    },
  },
  {
    codepoint: 983059,
    glyph: '󰀓',
    source: {
      tableName: 'InventoryItem',
      hash: 2031919265,
      fromRichText: false,
    },
  },
  {
    codepoint: 983062,
    glyph: '󰀖',
    source: {
      tableName: 'InventoryItem',
      hash: 1262901522,
      fromRichText: false,
    },
  },
  {
    codepoint: 57490,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 1262901522,
      fromRichText: false,
    },
  },
  {
    codepoint: 983063,
    glyph: '󰀗',
    source: {
      tableName: 'InventoryItem',
      hash: 1262901522,
      fromRichText: false,
    },
  },
  {
    codepoint: 983141,
    glyph: '󰁥',
    source: {
      tableName: 'InventoryItem',
      hash: 1262901522,
      fromRichText: false,
    },
  },
  {
    codepoint: 983102,
    glyph: '󰀾',
    source: {
      tableName: 'InventoryItem',
      hash: 1563930741,
      fromRichText: false,
    },
  },
  {
    codepoint: 983144,
    glyph: '󰁨',
    source: {
      tableName: 'InventoryItem',
      hash: 2031919264,
      fromRichText: false,
    },
  },
  {
    codepoint: 57489,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 790664813,
      fromRichText: false,
    },
  },
  {
    codepoint: 983071,
    glyph: '󰀟',
    source: {
      tableName: 'InventoryItem',
      hash: 668903197,
      fromRichText: false,
    },
  },
  {
    codepoint: 983072,
    glyph: '󰀠',
    source: {
      tableName: 'InventoryItem',
      hash: 2651551055,
      fromRichText: false,
    },
  },
  {
    codepoint: 983104,
    glyph: '󰁀',
    source: {
      tableName: 'InventoryItem',
      hash: 668903196,
      fromRichText: false,
    },
  },
  {
    codepoint: 61193,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 4249729126,
      fromRichText: false,
    },
  },
  {
    codepoint: 983373,
    glyph: '󰅍',
    source: {
      tableName: 'InventoryItem',
      hash: 4249729127,
      fromRichText: false,
    },
  },
  {
    codepoint: 61194,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 988980152,
      fromRichText: false,
    },
  },
  {
    codepoint: 983368,
    glyph: '󰅈',
    source: {
      tableName: 'InventoryItem',
      hash: 988980153,
      fromRichText: false,
    },
  },
  {
    codepoint: 983369,
    glyph: '󰅉',
    source: {
      tableName: 'InventoryItem',
      hash: 262821318,
      fromRichText: false,
    },
  },
  {
    codepoint: 983372,
    glyph: '󰅌',
    source: {
      tableName: 'InventoryItem',
      hash: 262821317,
      fromRichText: false,
    },
  },
  {
    codepoint: 983297,
    glyph: '󰄁',
    source: {
      tableName: 'InventoryItem',
      hash: 256339607,
      fromRichText: false,
    },
  },
  {
    codepoint: 983046,
    glyph: '󰀆',
    source: {
      tableName: 'Trait',
      hash: 3291013836,
      fromRichText: false,
    },
  },
  {
    codepoint: 983053,
    glyph: '󰀍',
    source: {
      tableName: 'Trait',
      hash: 500183315,
      fromRichText: false,
    },
  },
  {
    codepoint: 983107,
    glyph: '󰁃',
    source: {
      tableName: 'Trait',
      hash: 3824458961,
      fromRichText: false,
    },
  },
  {
    codepoint: 61182,
    glyph: '',
    source: {
      tableName: 'Trait',
      hash: 3221118171,
      fromRichText: false,
    },
  },
  {
    codepoint: 983060,
    glyph: '󰀔',
    source: {
      tableName: 'Trait',
      hash: 3263723277,
      fromRichText: false,
    },
  },
  {
    codepoint: 983374,
    glyph: '󰅎',
    source: {
      tableName: 'Trait',
      hash: 37177486,
      fromRichText: false,
    },
  },
  {
    codepoint: 983105,
    glyph: '󰁁',
    source: {
      tableName: 'Trait',
      hash: 3268862716,
      fromRichText: false,
    },
  },
  {
    codepoint: 983126,
    glyph: '󰁖',
    source: {
      tableName: 'Trait',
      hash: 157469667,
      fromRichText: false,
    },
  },
  {
    codepoint: 983127,
    glyph: '󰁗',
    source: {
      tableName: 'Trait',
      hash: 3488482714,
      fromRichText: false,
    },
  },
  {
    codepoint: 983131,
    glyph: '󰁛',
    source: {
      tableName: 'Trait',
      hash: 1096356879,
      fromRichText: false,
    },
  },
  {
    codepoint: 983061,
    glyph: '󰀕',
    source: {
      tableName: 'Trait',
      hash: 3078132110,
      fromRichText: false,
    },
  },
  {
    codepoint: 983106,
    glyph: '󰁂',
    source: {
      tableName: 'Trait',
      hash: 655301426,
      fromRichText: false,
    },
  },
  {
    codepoint: 983124,
    glyph: '󰁔',
    source: {
      tableName: 'Trait',
      hash: 2485406866,
      fromRichText: false,
    },
  },
  {
    codepoint: 983143,
    glyph: '󰁧',
    source: {
      tableName: 'Trait',
      hash: 2578642829,
      fromRichText: false,
    },
  },
  {
    codepoint: 983375,
    glyph: '󰅏',
    source: {
      tableName: 'Trait',
      hash: 3328352616,
      fromRichText: false,
    },
  },
  {
    codepoint: 57492,
    glyph: '',
    source: {
      tableName: 'Trait',
      hash: 4105407564,
      fromRichText: false,
    },
  },
  {
    codepoint: 983152,
    glyph: '󰁰',
    source: {
      tableName: 'Trait',
      hash: 3336638905,
      fromRichText: false,
    },
  },
  {
    codepoint: 57481,
    glyph: '',
    source: {
      tableName: 'Trait',
      hash: 37938188,
      fromRichText: false,
    },
  },
  {
    codepoint: 983133,
    glyph: '󰁝',
    source: {
      tableName: 'Trait',
      hash: 37938188,
      fromRichText: false,
    },
  },
  {
    codepoint: 983136,
    glyph: '󰁠',
    source: {
      tableName: 'Trait',
      hash: 4239423954,
      fromRichText: false,
    },
  },
  {
    codepoint: 983139,
    glyph: '󰁣',
    source: {
      tableName: 'Trait',
      hash: 3385340084,
      fromRichText: false,
    },
  },
  {
    codepoint: 57488,
    glyph: '',
    source: {
      tableName: 'Trait',
      hash: 37938188,
      fromRichText: false,
    },
  },
  {
    codepoint: 983140,
    glyph: '󰁤',
    source: {
      tableName: 'Trait',
      hash: 4043161234,
      fromRichText: false,
    },
  },
  {
    codepoint: 61184,
    glyph: '',
    source: {
      tableName: 'Trait',
      hash: 2519102437,
      fromRichText: false,
    },
  },
  {
    codepoint: 983370,
    glyph: '󰅊',
    source: {
      tableName: 'Trait',
      hash: 2679722414,
      fromRichText: false,
    },
  },
  {
    codepoint: 61185,
    glyph: '',
    source: {
      tableName: 'Trait',
      hash: 1577394840,
      fromRichText: false,
    },
  },
  {
    codepoint: 61230,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 988980155,
      fromRichText: false,
    },
  },
  {
    codepoint: 61229,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 2835214897,
      fromRichText: false,
    },
  },
  {
    codepoint: 61232,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 4249729124,
      fromRichText: false,
    },
  },
  {
    codepoint: 61228,
    glyph: '',
    source: {
      tableName: 'InventoryItem',
      hash: 262821319,
      fromRichText: false,
    },
  },
  {
    codepoint: 983371,
    glyph: '󰅋',
    source: {
      tableName: 'Trait',
      hash: 945613349,
      fromRichText: false,
    },
  },
  {
    codepoint: 57497,
    glyph: '',
    source: {
      tableName: 'Objective',
      hash: 1368601876,
      fromRichText: true,
    },
  },
  {
    codepoint: 57600,
    glyph: '',
    source: {
      tableName: 'Objective',
      hash: 49530695,
      fromRichText: true,
    },
  },
  {
    codepoint: 57601,
    glyph: '',
    source: {
      tableName: 'Objective',
      hash: 189060104,
      fromRichText: true,
    },
  },
  {
    codepoint: 57602,
    glyph: '',
    source: {
      tableName: 'Objective',
      hash: 75057024,
      fromRichText: true,
    },
  },
  {
    codepoint: 57603,
    glyph: '',
    source: {
      tableName: 'Objective',
      hash: 563593850,
      fromRichText: true,
    },
  },
  {
    codepoint: 57609,
    glyph: '',
    source: {
      tableName: 'Objective',
      hash: 141911950,
      fromRichText: true,
    },
  },
  {
    codepoint: 57607,
    glyph: '',
    source: {
      tableName: 'Objective',
      hash: 102976778,
      fromRichText: true,
    },
  },
  {
    codepoint: 57604,
    glyph: '',
    source: {
      tableName: 'Objective',
      hash: 212380697,
      fromRichText: true,
    },
  },
  {
    codepoint: 57605,
    glyph: '',
    source: {
      tableName: 'Objective',
      hash: 273389628,
      fromRichText: true,
    },
  },
  {
    codepoint: 57606,
    glyph: '',
    source: {
      tableName: 'Objective',
      hash: 215999859,
      fromRichText: true,
    },
  },
  {
    codepoint: 57685,
    glyph: '',
    source: {
      tableName: 'Objective',
      hash: 1217177904,
      fromRichText: true,
    },
  },
  {
    codepoint: 57686,
    glyph: '',
    source: {
      tableName: 'Objective',
      hash: 1351954994,
      fromRichText: true,
    },
  },
  {
    codepoint: 57656,
    glyph: '',
    source: {
      tableName: 'Objective',
      hash: 554293431,
      fromRichText: true,
    },
  },
  {
    codepoint: 983360,
    glyph: '󰅀',
    source: {
      tableName: 'Objective',
      hash: 554293431,
      fromRichText: true,
    },
  },
  {
    codepoint: 57608,
    glyph: '',
    source: {
      tableName: 'Objective',
      hash: 13215836,
      fromRichText: true,
    },
  },
  {
    codepoint: 57619,
    glyph: '',
    source: {
      tableName: 'Objective',
      hash: 43313268,
      fromRichText: true,
    },
  },
  {
    codepoint: 57682,
    glyph: '',
    source: {
      tableName: 'Objective',
      hash: 1476676901,
      fromRichText: true,
    },
  },
  {
    codepoint: 57683,
    glyph: '',
    source: {
      tableName: 'Objective',
      hash: 1260068656,
      fromRichText: true,
    },
  },
  {
    codepoint: 57684,
    glyph: '',
    source: {
      tableName: 'Objective',
      hash: 172143731,
      fromRichText: true,
    },
  },
  {
    codepoint: 57666,
    glyph: '',
    source: {
      tableName: 'Objective',
      hash: 30510483,
      fromRichText: true,
    },
  },
  {
    codepoint: 57654,
    glyph: '',
  },
  {
    codepoint: 983359,
    glyph: '󰄿',
  },
  {
    codepoint: 61239,
    glyph: '',
  },
  {
    codepoint: 61233,
    glyph: '',
  },
  {
    codepoint: 57667,
    glyph: '',
    source: {
      tableName: 'SandboxPerk',
      hash: 679036014,
      fromRichText: true,
    },
  },
  {
    codepoint: 57668,
    glyph: '',
    source: {
      tableName: 'SandboxPerk',
      hash: 1554078996,
      fromRichText: true,
    },
  },
  {
    codepoint: 57664,
    glyph: '',
    source: {
      tableName: 'SandboxPerk',
      hash: 1821367741,
      fromRichText: true,
    },
  },
  {
    codepoint: 57657,
    glyph: '',
    source: {
      tableName: 'SandboxPerk',
      hash: 35992462,
      fromRichText: true,
    },
  },
  {
    codepoint: 61198,
    glyph: '',
    source: {
      tableName: 'SandboxPerk',
      hash: 381243875,
      fromRichText: true,
    },
  },
  {
    codepoint: 57665,
    glyph: '',
  },
  {
    codepoint: 983311,
    glyph: '󰄏',
    source: {
      tableName: 'DamageType',
      hash: 3373582085,
      fromRichText: false,
    },
  },
  {
    codepoint: 983382,
    glyph: '󰅖',
  },
  {
    codepoint: 61244,
    glyph: '',
  },
  {
    codepoint: 61245,
    glyph: '',
  },
  {
    codepoint: 983343,
    glyph: '󰄯',
    source: {
      tableName: 'Stat',
      hash: 1591432999,
      fromRichText: false,
    },
  },
  {
    codepoint: 983344,
    glyph: '󰄰',
    source: {
      tableName: 'SandboxPerk',
      hash: 627527846,
      fromRichText: false,
    },
  },
  {
    codepoint: 983345,
    glyph: '󰄱',
    source: {
      tableName: 'Stat',
      hash: 2961396640,
      fromRichText: false,
    },
  },
  {
    codepoint: 983346,
    glyph: '󰄲',
    source: {
      tableName: 'Stat',
      hash: 447667954,
      fromRichText: false,
    },
  },
  {
    codepoint: 983348,
    glyph: '󰄴',
    source: {
      tableName: 'Stat',
      hash: 943549884,
      fromRichText: false,
    },
  },
  {
    codepoint: 983349,
    glyph: '󰄵',
    source: {
      tableName: 'Stat',
      hash: 4043523819,
      fromRichText: false,
    },
  },
  {
    codepoint: 983353,
    glyph: '󰄹',
    source: {
      tableName: 'Stat',
      hash: 1240592695,
      fromRichText: false,
    },
  },
  {
    codepoint: 983354,
    glyph: '󰄺',
    source: {
      tableName: 'Stat',
      hash: 4188031367,
      fromRichText: false,
    },
  },
  {
    codepoint: 983355,
    glyph: '󰄻',
    source: {
      tableName: 'Stat',
      hash: 1842278586,
      fromRichText: false,
    },
  },
  {
    codepoint: 983356,
    glyph: '󰄼',
    source: {
      tableName: 'Stat',
      hash: 155624089,
      fromRichText: false,
    },
  },
  {
    codepoint: 983358,
    glyph: '󰄾',
    source: {
      tableName: 'Stat',
      hash: 2523465841,
      fromRichText: false,
    },
  },
  {
    codepoint: 983325,
    glyph: '󰄝',
    source: {
      tableName: 'Stat',
      hash: 2996146975,
      fromRichText: false,
    },
  },
  {
    codepoint: 983333,
    glyph: '󰄥',
    source: {
      tableName: 'Stat',
      hash: 392767087,
      fromRichText: false,
    },
  },
  {
    codepoint: 983332,
    glyph: '󰄤',
    source: {
      tableName: 'Stat',
      hash: 1943323491,
      fromRichText: false,
    },
  },
  {
    codepoint: 983312,
    glyph: '󰄐',
    source: {
      tableName: 'Stat',
      hash: 1735777505,
      fromRichText: false,
    },
  },
  {
    codepoint: 983323,
    glyph: '󰄛',
    source: {
      tableName: 'Objective',
      hash: 119163662,
      fromRichText: false,
    },
  },
  {
    codepoint: 983340,
    glyph: '󰄬',
    source: {
      tableName: 'Objective',
      hash: 980790784,
      fromRichText: false,
    },
  },
  {
    codepoint: 983321,
    glyph: '󰄙',
    source: {
      tableName: 'InventoryItem',
      hash: 20603181,
      fromRichText: false,
    },
  },
  {
    codepoint: 983319,
    glyph: '󰄗',
    source: {
      tableName: 'InventoryItem',
      hash: 673268892,
      fromRichText: false,
    },
  },
  {
    codepoint: 983303,
    glyph: '󰄇',
    source: {
      tableName: 'InventoryItem',
      hash: 648507367,
      fromRichText: false,
    },
  },
  {
    codepoint: 983302,
    glyph: '󰄆',
    source: {
      tableName: 'InventoryItem',
      hash: 1436723983,
      fromRichText: false,
    },
  },
  {
    codepoint: 983305,
    glyph: '󰄉',
    source: {
      tableName: 'ItemCategory',
      hash: 49,
      fromRichText: false,
    },
  },
  {
    codepoint: 57456,
    glyph: '',
    source: {
      tableName: 'SandboxPerk',
      hash: 200616812,
      fromRichText: true,
    },
  },
  {
    codepoint: 57458,
    glyph: '',
    source: {
      tableName: 'SandboxPerk',
      hash: 72139184,
      fromRichText: true,
    },
  },
  {
    codepoint: 57457,
    glyph: '',
    source: {
      tableName: 'SandboxPerk',
      hash: 136649446,
      fromRichText: true,
    },
  },
  {
    codepoint: 983307,
    glyph: '󰄋',
    source: {
      tableName: 'Objective',
      hash: 5020780,
      fromRichText: false,
    },
  },
  {
    codepoint: 983308,
    glyph: '󰄌',
    source: {
      tableName: 'Objective',
      hash: 72589355,
      fromRichText: false,
    },
  },
  {
    codepoint: 983309,
    glyph: '󰄍',
    source: {
      tableName: 'Objective',
      hash: 121105404,
      fromRichText: false,
    },
  },
  {
    codepoint: 983193,
    glyph: '󰂙',
    source: {
      tableName: 'Objective',
      hash: 106925256,
      fromRichText: false,
    },
  },
  {
    codepoint: 983221,
    glyph: '󰂵',
    source: {
      tableName: 'Objective',
      hash: 738831275,
      fromRichText: false,
    },
  },
  {
    codepoint: 983211,
    glyph: '󰂫',
    source: {
      tableName: 'Objective',
      hash: 41039169,
      fromRichText: false,
    },
  },
  {
    codepoint: 983239,
    glyph: '󰃇',
    source: {
      tableName: 'Objective',
      hash: 550810786,
      fromRichText: false,
    },
  },
  {
    codepoint: 983219,
    glyph: '󰂳',
    source: {
      tableName: 'Objective',
      hash: 1328104731,
      fromRichText: false,
    },
  },
  {
    codepoint: 983234,
    glyph: '󰃂',
    source: {
      tableName: 'Objective',
      hash: 849228675,
      fromRichText: false,
    },
  },
  {
    codepoint: 983220,
    glyph: '󰂴',
    source: {
      tableName: 'Faction',
      hash: 1021210278,
      fromRichText: false,
    },
  },
  {
    codepoint: 983209,
    glyph: '󰂩',
    source: {
      tableName: 'Faction',
      hash: 611314723,
      fromRichText: false,
    },
  },
  {
    codepoint: 983171,
    glyph: '󰂃',
    source: {
      tableName: 'ActivityMode',
      hash: 4110605575,
      fromRichText: false,
    },
  },
  {
    codepoint: 983167,
    glyph: '󰁿',
    source: {
      tableName: 'InventoryItem',
      hash: 2388937381,
      fromRichText: false,
    },
  },
  {
    codepoint: 983381,
    glyph: '󰅕',
    source: {
      tableName: 'ActivityMode',
      hash: 1164760504,
      fromRichText: false,
    },
  },
  {
    codepoint: 983164,
    glyph: '󰁼',
    source: {
      tableName: 'InventoryItem',
      hash: 3388529809,
      fromRichText: false,
    },
  },
  {
    codepoint: 983173,
    glyph: '󰂅',
    source: {
      tableName: 'SandboxPerk',
      hash: 2133645639,
      fromRichText: false,
    },
  },
  {
    codepoint: 983169,
    glyph: '󰂁',
    source: {
      tableName: 'ActivityMode',
      hash: 2043403989,
      fromRichText: false,
    },
  },
  {
    codepoint: 983158,
    glyph: '󰁶',
    source: {
      tableName: 'ActivityMode',
      hash: 608898761,
      fromRichText: false,
    },
  },
  {
    codepoint: 57669,
    glyph: '',
    source: {
      tableName: 'ActivityMode',
      hash: 103143560,
      fromRichText: false,
    },
  },
  {
    codepoint: 57461,
    glyph: '',
    source: {
      tableName: 'Objective',
      hash: 119206183,
      fromRichText: true,
    },
  },
  {
    codepoint: 57671,
    glyph: '',
  },
  {
    codepoint: 57426,
    glyph: '',
  },
  {
    codepoint: 983326,
    glyph: '󰄞',
    source: {
      tableName: 'InventoryBucket',
      hash: 3313201758,
      fromRichText: false,
    },
  },
  {
    codepoint: 983334,
    glyph: '󰄦',
    source: {
      tableName: 'InventoryItem',
      hash: 213377779,
      fromRichText: false,
    },
  },
  {
    codepoint: 983327,
    glyph: '󰄟',
    source: {
      tableName: 'InventoryItem',
      hash: 432217080,
      fromRichText: false,
    },
  },
  {
    codepoint: 983376,
    glyph: '󰅐',
  },
  {
    codepoint: 983269,
    glyph: '󰃥',
  },
  {
    codepoint: 983377,
    glyph: '󰅑',
    source: {
      tableName: 'Objective',
      hash: 62478650,
      fromRichText: false,
    },
  },
];

export type TranslateManually =
  | 57495
  | 57654
  | 983359
  | 61239
  | 57665
  | 983382
  | 61244
  | 61245
  | 57671
  | 57426
  | 983376
  | 983269;

/*
 * Could not find a source for (did the definitions disappear?): 
 * Rocket Tracers

 * Unused rich text replacements (these should only be input actions replaced with the mapped buttons by the game): 
 * [Aim Down Sights]
 * [Alternate Weapon Action]
 * [Light Attack]
 * [Heavy Attack]
 * [Super]
 * [###DestinyNamedSubstitutions.ui_player_action_jump_button###]
 * [Shoot]
 * [Air Dodge]
 * [Sprint]
 * [afflicted|burdened|cursed]
 * [Block]
 * [Reload]
 * [Boost]
 * [Air Move]
 * [Brake]
 * [Stasis: Glyph 0]
 * [Stasis: Glyph 3 Locked]
 * [Stasis: Glyph 1 Locked]
 * [Stasis: Glyph 2 Locked]
 * [Insert Medal Here]
 */
